<template>
	<v-card elevation="0" class="ant-card pa-4">
		<v-card-title class="pa-0 d-flex align-center">
			<div class="v-typography--title1">{{ $t("product_details") }}</div>
			<v-spacer />
			<v-btn outlined text @click="$emit('edit')">
				<v-icon size="15" left>icon-edit</v-icon>
				<span class="v-typography--body-sm">{{ $t("edit") }}</span>
			</v-btn>
		</v-card-title>
		<v-divider class="my-3" />
		<v-row>
			<v-col cols="6" class="py-1">
				<strong>{{ $t("name") }}: </strong>{{ product.name[$lang] || product.name._default }}
			</v-col>
			<v-col cols="6" class="py-1">
				<strong>{{ $t("code") }}: </strong>{{ product.code }}
			</v-col>
			<v-col cols="6" class="py-1">
				<strong>{{ $t("product_group") }}: </strong>{{ productGroupName }}
			</v-col>
			<v-col cols="6" class="py-1">
				<strong>{{ $t("units") }}: </strong>
				<v-chip v-for="u in product.units" :key="u.code" :color="getUnitChipColor(u.code)" dark small class="ma-1">
					{{ $t(`$unit.${u.name}`) }}
				</v-chip>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { getUnitChipColor } from "../../../mixins/utils.mixin";
export default {
	name: "ProductDetails",
	props: {
		product: { type: Object, required: true },
		productGroupName: { type: String, required: true },
		lang: { type: String, required: true },
	},
	methods: { getUnitChipColor },
};
</script>
